import { render, staticRenderFns } from "./TransactionalityDetail.vue?vue&type=template&id=5d1387bf&scoped=true&"
import script from "./TransactionalityDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionalityDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransactionalityDetail.vue?vue&type=style&index=0&id=5d1387bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1387bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1387bf')) {
      api.createRecord('5d1387bf', component.options)
    } else {
      api.reload('5d1387bf', component.options)
    }
    module.hot.accept("./TransactionalityDetail.vue?vue&type=template&id=5d1387bf&scoped=true&", function () {
      api.rerender('5d1387bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/operations/components/transactionality/TransactionalityDetail.vue"
export default component.exports